<template>
  <div class="content">
    <div v-if="property.nuki" class="mb-4">
      <div v-if="property.nuki.lockId">
        <h5>
          {{ $t('streetDoor') }} - {{property.lock.title}}
        </h5>
        <div class="btn-group-horizontal">
          <button class="btn btn-primary mr-2" type="button" v-on:click="toggleLock('property', property._id, 1)">
            <i class="fa fa-unlock" aria-hidden="true"></i>
            {{ $t('unlock') }}
          </button>
          <button class="btn btn-primary" type="button" v-on:click="toggleLock('property', property._id, 2)">
            <i class="fa fa-lock" aria-hidden="true"></i>
            {{ $t('lock') }}
          </button>
        </div>
      </div>
      <div v-else-if="property.nuki.openerId">
        <button class="btn btn-primary" type="button" v-on:click="toggleLock('property', property._id, 3)">
          <i class="fa fa-bolt" aria-hidden="true"></i>
          {{ $t('streetDoor') }}
        </button>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table table-clean table-vcenter" style="width:100%;">
        <thead>
          <tr>
            <th width="20%" class="text-nowrap">{{ $t('room') }}</th>
            <th width="15%" class="text-nowrap">{{ $t('unit') }}</th>
            <th width="20%" class="text-nowrap">{{ $t('lockState') }}</th>
            <th width="10%">{{ $t('unlock') }}</th>
            <th width="10%">{{ $t('lock') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="room in pagination.rooms">
            <td>{{ room.name }}</td>
            <td>{{ room.units.name}}</td>
            <td>{{ room.lock.title }}</td>
            <td>
              <button class="btn btn-primary" type="button" v-on:click="toggleLock('room', room._id, 1, room.units.index + 1)" :disabled="!room.units.nuki">
                <i class="fa fa-unlock" aria-hidden="true"></i>
              </button>
            </td>
            <td>
              <button class="btn btn-primary" type="button" v-on:click="toggleLock('room', room._id, 2, room.units.index + 1)" :disabled="!room.units.nuki">
                <i class="fa fa-lock" aria-hidden="true"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="dataTables_wrapper">
      <div class="row">
        <div class="col-sm-12 col-md-5">
          <div class="dataTables_info" id="dt-basic_info" role="status" aria-live="polite">
            {{ $t('showing') }}
            {{ pagination.first }}
            <span v-if="pagination.rooms.length">
              {{ $t('to') }} {{ pagination.first + pagination.rooms.length - 1 }}
            </span>
            {{ $t('of') }}
            {{ pagination.total }}
            {{ $t('entries') }}
          </div>
        </div>
        <div class="col-sm-12 col-md-7">
          <pagination v-bind:pages="pagination.pages"></pagination>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Pagination from '../../pagination/Pagination.vue';
import io from 'socket.io-client';

//import moment from 'moment';

export default {
  name: 'RoomsList',
  components:{
    Pagination
  },
  data: () => ({
    pagination: {
      rooms: [],
      pages: 1,
      total: 0,
      first: 0
    },
    property: {
      _id: "",
      name: "",
      lock: {
        state: "",
        title: "",
        doorState: ""
      }
    },
    socket: {},
  }),
  created(){
    const propSlug = this.$route.params.property;
    let property = this.$store.state.host.properties.find(p => p.slug == propSlug);
    this.property.name = property.name;
    this.property._id = property._id
    this.property.nuki = property.nuki

    if(this.property.nuki && this.property.nuki.lockId){
      this.property.lock.state = "";
      this.property.lock.action = "";
      this.property.lock.title = "Loading ...";
      this.property.lock.doorState = "";
    }

    this.loadRooms();
  },
  mounted(){
  },
  beforeDestroy(){
    this.socket.close()
    //this.socket.off('lockStatus');
  },
  methods: {
    loadRooms: function(){

      let url = '/units?propertyId=' + this.property._id;

      const page = this.$route.query.page || 1;
      const roomSlug = this.$route.params.room;

      if(roomSlug){
        url += '&roomSlug=' + roomSlug;
      }

      fetch(process.env.VUE_APP_API + url + '&limit=20&skip=' + ((page - 1) * 20), {
        method: 'get',
        credentials: 'include',
        headers: {
          "Content-type": "application/json",
          "Accept": "application/json",
          "Accept-Charset": "utf-8",
          'CSRF-Token': this.$csrf
        }
      })
      .then(response => {
        return response.json();
      })
      .then(result => {
        console.log("result")
        console.log(result);
        if(!result.error){

          this.socket = io(process.env.VUE_APP_NUKI);
          this.socket.on('connect', () => {
            let token = this.$cookies.get('token');
            let session = this.$cookies.get('session');
            if(!token){
              return;
            }else if(!session){
              this.$getAccessToken()
              .then(response => {
                session = this.$cookies.get('session');
                this.socket.emit('authentication', {token: token, session: session, propertyId: this.property._id});
              });
            }else{
              this.socket.emit('authentication', {token: token, session: session, propertyId: this.property._id});
            }
          });

          this.socket.on('authenticated', function() {
            console.log("authenticated")
          });

          this.socket.on('disconnect', (reason) => {
            console.log(`Disconnected: ${reason}`);
          });

          this.socket.on('lockStatus', (response) => {
            let data = JSON.parse(response)
            let lock = this.pagination.rooms.find(r => r.units.nuki && r.units.nuki.lockId == data.lockId);
            if(lock){
              lock = lock.lock;
            }else if(this.property.nuki && this.property.nuki.lockId == data.lockId){
              lock = this.property.lock;
            }
            if(!lock) return;

            if(lock.state != data.state || lock.doorState != data.doorState){
              lock.state = data.state;
              lock.doorState = data.doorState;

              if(lock.state == '0'){
                lock.title = this.$t('uncalibrated');
              }else if(lock.state == '1'){
                lock.title = this.$t('locked');
              }else if(lock.state == '2'){
                lock.title = this.$t('unlocking');
              }else if(lock.state == '3'){
                lock.title = this.$t('unlocked');
              }else if(lock.state == '4'){
                lock.title = this.$t('locking');
              }else if(lock.state == '5'){
                lock.title =  this.$t('unlatched');
              }else if(lock.state == '6'){
                lock.title = this.$t('unlocked');
              }else if(lock.state == '7'){
                lock.title = this.$t('unlatching');
              }else if(lock.state == '254'){
                lock.title = this.$t('blocked');
              }else{
                lock.title = this.$t('undefined');
              }

              if(lock.doorState == '1'){
                lock.title += ' - ' + this.$t('deactivated');
              }else if(lock.doorState == '2'){
                lock.title += ' - ' + this.$t('closed');
              }else if(lock.doorState == '3'){
                lock.title += ' - ' + this.$t('opened');
              }else if(lock.doorState == '4'){
                lock.title += ' - ' + this.$t('unknown');
              }else if(lock.doorState == '5'){
                lock.title += ' - ' + this.$t('calibrating');
              }
            }
          });

          result.rooms = result.rooms.map(r => {
            if(r.units.nuki && r.units.nuki.lockId){
              r.lock = {
                state: "",
                title: this.$t('loading') + " ...",
                doorState: ""
              }
            }else{
              r.lock = {title: this.$t('notEnabled')}
            }
            return r;
          });

          console.log("tukaj smo");
          console.log(result)

          return this.pagination = result;
        }
      })
    },

    toggleLock: function(type, _id, action, unitId = null){
      return fetch( process.env.VUE_APP_NUKI + '/opener', {
        method : 'post',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'CSRF-Token': this.$csrf
        },
        body: JSON.stringify({
          "action": action,
          "type": type,
          "_id": _id,
          "unitId": unitId
        })
      })
      .then(response => response.json())
      .then(response => {
        console.log(response);
      });
    }
  }
};
</script>

<i18n>
{
  "en": {
    "streetDoor": "Street Door",
    "unit": "Unit",
    "room": "Room type",
    "lockState": "Lock state",
    "lock": "Lock",
    "unlock": "Unlock",
    "showing": "Showing",
    "to": "to",
    "of": "of",
    "entries": "entries",
    "locked": "Locked",
    "unlocked": "Unlocked",
    "locking": "Locking",
    "unlocking": "Unlocking",
    "blocked": "Motor Blocked",
    "opened": "Door opened",
    "closed": "Door closed",
    "unlatching": "Unlatching",
    "unlatched": "Unlatched",
    "undefined": "Undefined",
    "deactivated": "Door sensor deactivated",
    "unknown": "Door sensor state unknown",
    "calibrating": "Door sendor calibrating",
    "loading": "Loading",
    "notEnabled": "Smart lock is not enabled"
  },
  "sl": {
    "streetDoor": "Vrata nastanitve",
    "unit": "Enota",
    "room": "Tip sobe",
    "lockState": "Stanje ključavnice",
    "lock": "Zakleni",
    "unlock": "Odkleni",
    "showing": "Prikazanih",
    "to": "do",
    "of": "od",
    "entries": "vnosov",
    "locked": "Zaklenjeno",
    "unlocked": "Odklenjeno",
    "locking": "Zaklepa",
    "unlocking": "Odklepa",
    "blocked": "Blokiran motor",
    "opened": "Vrata odprta",
    "closed": "Vrata zaprta",
    "unlatching": "Unlatching",
    "unlatched": "Unlatched",
    "undefined": "Nedefinirano",
    "deactivated": "Senzor na vratih deaktiviran",
    "unknown": "Stanje senzorja na vratih neznano",
    "calibrating": "Senzor na vratih se kalibrira",
    "loading": "Nalaganje",
    "notEnabled": "Pametna ključavnica ni omogočena"
  }
}
</i18n>
